<template>
  <div class="sales-order-number" @click="showOverlay">{{ sono }}</div>
</template>

<script>

import SalesOrderOverlay from '../overlays_OLD/sales_orders/SalesOrderOverlay'
import Vue from 'vue'

export default {
  name: 'SalesOrder',
  props: ['sono'],
  components: {},
  methods: {
    showOverlay () {
      // Show the overlay.
      const sono = this.sono.trim()
      const SalesOrderOverlayClass = Vue.extend(SalesOrderOverlay)
      const salesOrderOverlay = new SalesOrderOverlayClass({
        propsData: {sono: sono}
      })
      salesOrderOverlay.$mount()
      const app = document.getElementById('app')
      app.appendChild(salesOrderOverlay.$el)
    }
  },
  beforeMount () {

  }
}
</script>

<style scoped>
  .sales-order-number {
    cursor: pointer;
    color: blue;
  }
</style>
